export default __webpack_public_path__ + "static/media/corruptionfloor.d42e51ef.png";